import { axiosInstance as axios } from './axiosManager'

const API_URL = process.env.REACT_APP_HOST_API + '/reasoning-gap'

export const getReasoningGapTask = async (sessionId, userId) => {
  const response = await axios.get(`${API_URL}/sessions/${sessionId}/task`, { params: { userId } })
  return response.data
}

export const submitReasoningGap = async (sessionId, { userId, code, explanation, timeOnTaskMs }) => {
  const response = await axios.post(`${API_URL}/sessions/${sessionId}/submit`, { userId, code, explanation, timeOnTaskMs })
  return response.data.submission
}

export const getReasoningGapSubmission = async (submissionId, userId) => {
  const response = await axios.get(`${API_URL}/submissions/${submissionId}`, { params: { userId } })
  return response.data.submission
}

export const reportReasoningGapTests = async (submissionId, payload) => {
  const response = await axios.post(`${API_URL}/submissions/${submissionId}/test-results`, payload)
  return response.data.submission
}

export const rateReasoningGapFeedback = async (submissionId, userId, rating) => {
  await axios.post(`${API_URL}/submissions/${submissionId}/feedback-rating`, { userId, rating })
}

export const submitReasoningGapSurvey = async (submissionId, userId, survey) => {
  await axios.post(`${API_URL}/submissions/${submissionId}/survey`, { userId, survey })
}

export const getReasoningGapSubmissions = async (sessionId) => {
  const response = await axios.get(`${API_URL}/sessions/${sessionId}/submissions`)
  return response.data
}

export const reanalyzeReasoningGap = async (submissionId) => {
  const response = await axios.post(`${API_URL}/submissions/${submissionId}/reanalyze`)
  return response.data
}

export const getReasoningGapContent = async (sessionId) => {
  const response = await axios.get(`${API_URL}/sessions/${sessionId}/content`)
  return response.data
}

// payload: { intro, example: { x, y } } | { reset: true }, plus dryRun: true for a preview.
export const saveReasoningGapContent = async (sessionId, payload) => {
  const response = await axios.put(`${API_URL}/sessions/${sessionId}/content`, payload)
  return response.data
}

export const getReasoningGapChat = async (sessionId, userId) => {
  const response = await axios.get(`${API_URL}/sessions/${sessionId}/chat`, { params: { userId } })
  return response.data
}

// Sends the question with the student's current code and explanation; resolves to the
// stored [question, reply] pair.
export const sendReasoningGapChat = async (sessionId, { userId, message, code, explanation }) => {
  const response = await axios.post(`${API_URL}/sessions/${sessionId}/chat`, { userId, message, code, explanation })
  return response.data.messages
}

// Another attempt after feedback; resolves to the reset submission (status 'submitted').
export const resubmitReasoningGap = async (submissionId, { userId, code, explanation, timeOnTaskMs }) => {
  const response = await axios.post(`${API_URL}/submissions/${submissionId}/resubmit`, { userId, code, explanation, timeOnTaskMs })
  return response.data.submission
}

// Every student's logged activity (runs, pastes, focus changes, snapshots, chat and submit
// events) for a session, keyed by user id. Stored by the shared telemetry endpoint.
export const getReasoningGapActivity = async (sessionId) => {
  const response = await axios.get(`${process.env.REACT_APP_HOST_API}/telemetry/session/${sessionId}`)
  return response.data.eventsByUser
}

// Shared random-assignment link: which session of the pair this student goes to.
export const assignReasoningGapSession = async (a, b) => {
  const response = await axios.get(`${API_URL}/assign/${a}/${b}`)
  return response.data.sessionId
}

export const getReasoningGapPartners = async (sessionId) => {
  const response = await axios.get(`${API_URL}/sessions/${sessionId}/partners`)
  return response.data
}

// Pairs a session with one of the other group's type (same quiz); saved on both sessions.
export const pairReasoningGapSession = async (sessionId, partnerId) => {
  const response = await axios.post(`${API_URL}/sessions/${sessionId}/pair`, { partnerId })
  return response.data
}
